import type { ScorecardField, ScorecardRatingConfig, ScorecardValue } from "@/types/scorecard";

/** A field counts as answered when it has an explicit value (0 and false included). */
export function isFieldCompleted(field: ScorecardField, value: ScorecardValue | undefined): boolean {
	if (field.field_type === "boolean") return value === true || value === false;
	return value !== undefined && value !== null && value !== "";
}

/** Rating config with defaults applied for malformed/missing options. */
export function getRatingConfig(field: ScorecardField): ScorecardRatingConfig {
	if (field.options && !Array.isArray(field.options)) {
		const { min, max } = field.options;
		if (Number.isFinite(min) && Number.isFinite(max) && max > min) return field.options;
	}
	return { min: 1, max: 5 };
}

/** Dropdown options, tolerating malformed configs. */
export function getDropdownOptions(field: ScorecardField): string[] {
	return Array.isArray(field.options) ? field.options.filter(Boolean) : [];
}
